export enum CouponTypeKeys {
    RESTAURANT_COUPON = "restaurant_coupon",
    PAYMENT_COUPON = "payment_coupon",
}
